// @flow
import * as R from "ramda"
import type AdditionalService from "@kiwicom/frontend-common/records/AdditionalService"

import mapperSeatingAncillary from "../mapper/services/mapperSeatingAncillary"
import { SERVICES, SERVICES_STATUSES } from "mmb/consts/additionalServices"
import type { SeatingAncillaryInput } from "../mapper/services/mapperSeatingAncillary"
import { SEATING_OPTIONS } from "./consts"
import { cuckooEvents } from "../../../../../../../common/consts/enums"
import cuckoo from "../../../../../../../common/services/cuckoo/cuckoo"
import type { SeatingAncillary } from "../../scenes/BookingAncillary/consts/types"

export const mapperRaw = (
  additionalServicesOrderedSet: AdditionalService,
): SeatingAncillaryInput => {
  const seatingAdditionalServicesFilteredtStatuses = additionalServicesOrderedSet
    .filter(
      service =>
        service.category === SERVICES.SEATING &&
        [SERVICES_STATUSES.CONFIRMED, SERVICES_STATUSES.PENDING, SERVICES_STATUSES.CLOSED].includes(
          service.status,
        ),
    )
    .toJS()

  const allSeatsFromAdditionalServices = seatingAdditionalServicesFilteredtStatuses
    .filter(st => st.params?.requestedSeats?.segments)
    .map((s, index) => {
      const seatingSegmentsData = s.params.requestedSeats.segments
      const allSeatsInner = Object.entries(seatingSegmentsData).map(([segment_id, segment]) => {
        // $FlowFixMe
        const seats = Object.entries(segment).map(([passenger_id, seat_id]) => {
          return {
            segment_id,
            passenger_id: Number(passenger_id),
            seat_id,
            extra_id: s.id,
            id: index,
            amount: s.payment.amount,
            currency: s.payment.currency,
          }
        })
        return seats
      })
      return allSeatsInner
    })
    .reduce((acc, seatsInSegment) => acc.concat(...seatsInSegment), [])

  const result = seatingAdditionalServicesFilteredtStatuses.map(additionalService => {
    const allSeatsPerExtraId = allSeatsFromAdditionalServices.filter(
      seatsData => seatsData.extra_id === additionalService.id,
    )
    return {
      id: 1,
      extra_id: additionalService.id,
      items: allSeatsPerExtraId.map(seatData => ({
        option: SEATING_OPTIONS.PARTICULAR_SEAT,
        price: {
          amount: String(seatData.amount / allSeatsPerExtraId.length),
          base: "0",
          currency: (seatData && seatData.currency.toUpperCase()) || "EUR",
          merchant: "0",
          service: "0",
          service_flat: "0",
        },
        seats: [
          {
            booked_seat: seatData.seat_id,
            passenger_id: seatData.passenger_id,
            seat: seatData.seat_id,
          },
        ],
        segment_code: seatData.segment_id,
      })),
    }
  })

  return result
}

// $FlowFixMe
export const mapperAdditionalServicesToAncillariesSeating = R.compose(
  mapperSeatingAncillary,
  mapperRaw,
)

export const getSeatingFromAncillariesAndAdditionalServices = (
  services: SeatingAncillary,
  ancillaries: SeatingAncillary,
): SeatingAncillary => {
  const ancillariesExtraIds = ancillaries.filter(a => a.extraId).map(a => a.extraId)

  const servicesNotInAncillaries = services.filter(a => !ancillariesExtraIds.includes(a.extraId))

  if (ancillariesExtraIds.length !== 0 && servicesNotInAncillaries.length > 0) {
    cuckoo.track(cuckooEvents.MMB_SEATING_ANCILLARIES_DATA_INCONSISTENCY)
  }

  return [...ancillaries, ...servicesNotInAncillaries]
}
